import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryAdjustmentForm from "./components/SalaryAdjustmentForm";

const EditSalaryAdjustment = () => {

	const { adjustmentId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<SalaryAdjustmentForm recordId={adjustmentId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditSalaryAdjustment;